/* eslint-disable jsx-a11y/no-static-element-interactions */
// @flow
import React, { PureComponent } from 'react';
import { Link } from 'react-router-dom';

import { nullContactForm } from 'types/ContactForm7';
import type { ContactFormType } from 'types/ContactForm7';
import type { ThemeType } from 'types/Faq';
import { dynamicClassName } from 'utils/dynamicClassName';

export type StateProps = {
  contactFormList: Array<ContactFormType>
};

export type DispatchProps = {
  fetchAllContactForms: () => void
};

type Props = DispatchProps &
  StateProps & {
    faqThemes?: Array<ThemeType>,
    slug: string
  };

type State = {
  isOpen: boolean
};

class ContactAndFaqSelector extends PureComponent<Props, State> {
  _FormObjectSelector: ?HTMLElement;

  static defaultProps = {
    faqThemes: []
  };

  state: State = {
    isOpen: false
  };

  componentDidMount() {
    const { contactFormList, fetchAllContactForms } = this.props;

    //* fetch necessary data
    if (!contactFormList || !contactFormList.length) {
      fetchAllContactForms();
    }
  }

  componentDidUpdate(prevProps: Props, prevState: State) {
    if (prevState.isOpen === this.state.isOpen) {
      this.setState({
        isOpen: false
      });
    }
  }

  handleClickDropDown = (e: MouseEvent) => {
    e.preventDefault();

    if (!this.state.isOpen) {
      document.addEventListener('mousedown', this.handleClickOutside, { once: true });
    }

    this.setState(prevState => ({
      isOpen: !prevState.isOpen
    }));
  };

  handleClickOutside = (event: MouseEvent) => {
    if (this._FormObjectSelector && !this._FormObjectSelector.contains((event.target: any))) {
      this.handleClickDropDown(event);
    }
  };

  render() {
    const { contactFormList, faqThemes, slug } = this.props;
    const { isOpen } = this.state;

    if (!faqThemes) {
      return null;
    }
    const classNames = dynamicClassName('dropdown dropdown--contact');
    isOpen && classNames.add('is-open');

    const formByDefault = contactFormList && !!contactFormList.length ? contactFormList[0] : nullContactForm;

    let formByDefaultObject = {
      description: '',
      id: '',
      name: '',
      slug: ``
    };

    if (formByDefault) {
      formByDefaultObject = {
        description: '',
        id: '',
        name: formByDefault.title,
        slug: `nous-contacter?q=${formByDefault.slug}`
      };
    }
    const objectList = faqThemes
      .concat(formByDefaultObject)
      .sort((a, b) => (a.name > b.name ? 1 : a.name < b.name ? -1 : 0));

    let label = 'Choisir un sujet';
    if (slug && formByDefaultObject) {
      const selectedObject = objectList.filter(object => object.slug === slug);

      label = selectedObject.length ? selectedObject[0].name : formByDefaultObject.name;
    }

    return (
      <div className={classNames.build()}>
        <span
          className="dropdown__head ft-h6 ft-up"
          onClick={this.handleClickDropDown}
          ref={ref => (this._FormObjectSelector = ref)}
        >
          <span className="dropdown__label">{label}</span>
        </span>
        <div className="dropdown__list">
          <span className="dropdown__head ft-h6 ft-up" onClick={this.handleClickDropDown}>
            <span className="dropdown__label">{label}</span>
          </span>
          <div className="dropdown__wrapper">
            {/* // https://www.codementor.io/blog/react-optimization-5wiwjnf9hj#9-avoid-using-index-as-key-for-map */}
            {objectList.map(theme => {
              return (
                <Link key={theme.slug} title={theme.name} to={`/contact/${theme.slug}`}>
                  {theme.name}
                </Link>
              );
            })}
          </div>
        </div>
      </div>
    );
  }
}

export default ContactAndFaqSelector;
